// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2lYxy","label":"Category_label__KJ03A","content":"Category_content__2eks0","header":"Category_header__7UU2_","location":"Category_location__sBV7w"};